import React from 'react';

const repeatOnSvg = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_47_183)">
            <g clip-path="url(#clip1_47_183)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8626 0.861764C11.1229 0.601417 11.5451 0.601417 11.8054 0.861764L13.8054 2.86176C14.0657 3.12212 14.0657 3.54422 13.8054 3.80458L11.8054 5.80458C11.5451 6.06492 11.1229 6.06492 10.8626 5.80458C10.6023 5.54422 10.6023 5.12212 10.8626 4.86176L11.7245 3.99984H5.66732C3.46884 3.99984 1.66732 5.80136 1.66732 7.99984C1.66732 8.36804 1.36884 8.6665 1.00065 8.6665C0.632461 8.6665 0.333984 8.36804 0.333984 7.99984C0.333984 5.06498 2.73246 2.6665 5.66732 2.6665H11.7245L10.8626 1.80458C10.6023 1.54422 10.6023 1.12212 10.8626 0.861764ZM15.6673 7.99984C15.6673 7.63164 15.3689 7.33317 15.0007 7.33317C14.6325 7.33317 14.334 7.63164 14.334 7.99984C14.334 10.1983 12.5325 11.9998 10.334 11.9998H4.27679L5.13872 11.1379C5.39907 10.8776 5.39907 10.4554 5.13872 10.1951C4.87837 9.93477 4.45626 9.93477 4.19591 10.1951L2.19591 12.1951C1.93556 12.4554 1.93556 12.8776 2.19591 13.1379L4.19591 15.1379C4.45626 15.3982 4.87837 15.3982 5.13872 15.1379C5.39907 14.8776 5.39907 14.4554 5.13872 14.1951L4.27679 13.3332H10.334C13.2689 13.3332 15.6673 10.9347 15.6673 7.99984Z" fill="#9FFF9A" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_47_183">
                <rect width="16" height="16" fill="white" />
            </clipPath>
            <clipPath id="clip1_47_183">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const repeatOffSvg = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_44_172)">
            <g clip-path="url(#clip1_44_172)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8626 0.861764C11.1229 0.601417 11.5451 0.601417 11.8054 0.861764L13.8054 2.86176C14.0657 3.12212 14.0657 3.54422 13.8054 3.80458L11.8054 5.80458C11.5451 6.06492 11.1229 6.06492 10.8626 5.80458C10.6023 5.54422 10.6023 5.12212 10.8626 4.86176L11.7245 3.99984H5.66732C3.46884 3.99984 1.66732 5.80136 1.66732 7.99984C1.66732 8.36804 1.36884 8.6665 1.00065 8.6665C0.632461 8.6665 0.333984 8.36804 0.333984 7.99984C0.333984 5.06498 2.73246 2.6665 5.66732 2.6665H11.7245L10.8626 1.80458C10.6023 1.54422 10.6023 1.12212 10.8626 0.861764ZM15.6673 7.99984C15.6673 7.63164 15.3689 7.33317 15.0007 7.33317C14.6325 7.33317 14.334 7.63164 14.334 7.99984C14.334 10.1983 12.5325 11.9998 10.334 11.9998H4.27679L5.13872 11.1379C5.39907 10.8776 5.39907 10.4554 5.13872 10.1951C4.87837 9.93477 4.45626 9.93477 4.19591 10.1951L2.19591 12.1951C1.93556 12.4554 1.93556 12.8776 2.19591 13.1379L4.19591 15.1379C4.45626 15.3982 4.87837 15.3982 5.13872 15.1379C5.39907 14.8776 5.39907 14.4554 5.13872 14.1951L4.27679 13.3332H10.334C13.2689 13.3332 15.6673 10.9347 15.6673 7.99984Z" fill="black" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_44_172">
                <rect width="16" height="16" fill="white" />
            </clipPath>
            <clipPath id="clip1_44_172">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

);

const RepeatButton = ({ isRepeat, toggleRepeat }) => {
    return (
        <button className={`repeat-button ${isRepeat ? 'active' : ''}`} onClick={toggleRepeat}>
            {isRepeat ? repeatOnSvg : repeatOffSvg}
        </button>
    );
};

export default RepeatButton;